import OrganizationArrivalRatesPerDayTable from "../../tables/daily/OrganizationArrivalRatesPerHourTable";
import LineGraph from "../../../daily/LineGraph";

import { Box, Separator } from "@chakra-ui/react";
import EnterpriseReportSummary from "../../../reports/EnterpriseReportSummary";
import { buildArrivalInsights } from "../../../../store/reportEnterpriseInsights";

const OrganizationArrivalRatesPerHour = ({ reportIndex = 1, data: reportData, renderConfig }) => {
  const title = `${reportIndex}.1. Entire Organization`;
  const insights = buildArrivalInsights(
    [{ ...reportData, scopeName: "Entire Organization" }],
    { scopeLabel: "Organization" }
  );

  const { average, min, max, total, chart } = reportData;

  return (
    <>
      <Box className="reportContainer" mt="20px">
        <EnterpriseReportSummary
          title="Daily Hourly Arrival Demand Summary"
          kpis={insights.kpis}
          tables={insights.tables}
          notes={insights.notes}
        />
        <OrganizationArrivalRatesPerDayTable
          average={average}
          min={min}
          max={max}
          total={total}
          title={title}
          renderConfig={renderConfig}
        />

        <Box mt="20px" mb="20px">
          <LineGraph
            chart={chart}
            height={"300px"}
            title={"Entire Organization Arrival Rates, Hour by Hour Comparison"}
          />
        </Box>
        <Separator />
      </Box>
    </>
  );
};

export default OrganizationArrivalRatesPerHour;
